const {React} = require('react');
const locationsList = require('../static-content/locale-menu.json');

const handleFormerInternalURLs = (pageGeo, url) => {
  if(url) {
    if (url.includes("insight.credera.com")) {
      url = url.replace(/^.*(?=insight\.credera\.com)/, 'https://');

      return url;
    }

    if(url.includes("credera.co.uk/en-gb")) {
      url = url.replace("credera.co.uk/en-gb", "credera.com/en-gb");
    } else if(url.includes("credera.co.uk")) {
      url = url.replace("credera.co.uk", "credera.com/en-gb");
    } else if(url.includes("credera.de")) {  
      url = url.replace("credera.de", "credera.com/de-de");
    } else if(url.includes("credera.com.au")) {  
      url = url.replace("credera.com.au", "credera.com/en-au");
    }

    if (
      url.includes('credera.com/') &&
      !url.includes('/en-au') &&
      !url.includes('/en-gb') &&
      !url.includes('/en-us') &&
      !url.includes('/de-de') &&
      !url.includes('/en-in')
    ) {
      pageGeo = pageGeo ? pageGeo : 'en-us';
      url = url.replace('credera.com/', 'credera.com/' + pageGeo + '/');
    }
  }

  return url;
}
  
const isInternalLink = (url) => {
  if(url) {
    if ((url.includes('credera.com') && !url.includes('insight.credera.com')) || !url.includes('https')) {
      return true;
    } else {
      return false;
    }
  } else {
    return false
  }
}  

const doesLinkContainLocale = url => {
  return (
    url.includes('/en-au') ||
    url.includes('/en-gb') ||
    url.includes('/en-us') ||
    url.includes('/de-de') ||
    url.includes('/en-in')
  );
};  

module.exports.isInternalLink = isInternalLink;
module.exports.handleFormerInternalURLs = handleFormerInternalURLs;
module.exports.doesLinkContainLocale = doesLinkContainLocale;
